/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOvercast = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.17 5.442 1.996-2.995 1.665 1.11-1.997 2.995zm2.278 1.725 2.996-1.997 1.11 1.664-2.996 1.997zM19 14h-1c0-3.9-3.1-7-7-7-3.2 0-6 2.3-6.8 5.3C2.3 13.1 1 14.9 1 17c0 2.8 2.2 5 5 5h13c2.2 0 4-1.8 4-4s-1.8-4-4-4zm0 6H6c-1.7 0-3-1.3-3-3 0-1.4.9-2.6 2.3-2.9l.7-.2.1-.7C6.4 10.8 8.5 9 11 9c2.8 0 5 2.2 5 5-2.2 0-4 1.8-4 4h2c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2s-.9 2-2 2zm1-10h3v2h-3zm-7-8h2v3h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgOvercast as Overcast };
